import moment from 'moment';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { DashboardAction } from '../actions/DashboardActions';
import { TransactionJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import { Dashboard, DashboardFilter, DashboardResponseModel } from '../../domain/dashboard/DashboardDomains';
import { FormicaTimePickerDate } from '../../components/custom/custom-time-picker/TimePickerDomain';

const defaultStartDate: FormicaTimePickerDate = {
  type: 'Absolute',
  label: 'Last 3 Year',
  value: moment().subtract(3, 'year').startOf('year').toDate(),
};

const defaultEndDate: FormicaTimePickerDate = {
  type: 'Now',
  label: 'Now',
  value: 'Now',
};

export interface DashboardState {
  transactions: TransactionJsonModel[] | undefined;
  dashboard: Dashboard;
  filter: DashboardFilter;
  response: DashboardResponseModel;
  loading: boolean;
  editMode: boolean;
}

export const initialState: DashboardState = {
  transactions: [],
  dashboard: {
    id: '',
    name: '',
    selectedTransaction: undefined,
    startDate: defaultStartDate,
    endDate: defaultEndDate,
    charts: [],
    layouts: [],
    collaborators: [],
    permission: 'No Permission',
    rulePerformance: [],
    emailSettings: {
      enabled: false,
      emails: [],
      charts: [],
      period: {
        type: 'daily',
        day: 'saturday',
        hour: 17,
        minute: 0,
      },
    },
  },
  filter: {
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  },
  response: {
    name: '',
    charts: [],
    rulePerformance: [],
  },
  editMode: false,
  loading: true,
};

export const dashboardReducer = (state: DashboardState = initialState, action: ReduxBaseAction<any, DashboardAction>) => {
  switch (action.type) {
    case 'CHANGE_TRANSACTIONS':
      return { ...state, transactions: action.payload };
    case 'CHANGE_DASHBOARD_RESPONSE':
      return { ...state, response: action.payload };
    case 'CHANGE_DASHBOARD':
      return { ...state, dashboard: action.payload };
    case 'CHANGE_LOADING':
      return { ...state, loading: action.payload };
    case 'CHANGE_EDIT_MODE':
      return { ...state, editMode: action.payload };
    case 'CHANGE_DASHBOARD_FILTER':
      return { ...state, filter: action.payload };
    case 'CLEAR_DASHBOARD':
      return {
        dashboard: {
          ...initialState.dashboard,
          selectedTransaction: '',
        },
        filter: initialState.filter,
        response: initialState.response,
        transactions: initialState.transactions,
        loading: false,
        editMode: false,
      };
    default: {
      return state;
    }
  }
};
